import styled from 'styled-components';

const PopupMenuContainer = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  list-style: none;
  position: ${({ $absolute }) => ($absolute ? 'absolute' : 'sticky')};
  top: ${({ $top }) => ($top ? `${$top}px` : 'auto')};
  left: ${({ $left }) => ($left ? `${$left}px` : 'auto')};
  width: max-content;
  padding: 0;
  margin: 0;
  margin-top: 0px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 1;
  max-width: 200px;
`;

const PopupMenuItem = styled.li`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  line-height: 35px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  width: 100%;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
  color: ${({ $disabled, theme }) =>
    $disabled ? theme.COLOR_GREY4 : '#000000'};
  @media (hover: hover) {
    &:hover {
      background-color: ${({ $disabled }) =>
        $disabled ? 'transparent' : '#f5f5f5'};
    }
  }
`;

// Styled component for the popup menu items container
const PopupMenuItemsContainer = styled.div`
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: sticky;
  left: ${({ $left }) => ($left ? `${$left}px` : 'auto')};
  top: ${({ $top, $absolute }) =>
    $top && $absolute ? `${$top - 20}px` : '240px'};
  z-index: 2;
  width: max-content;
`;

export { PopupMenuContainer, PopupMenuItem, PopupMenuItemsContainer };
